import { ReactNode } from "react";

import { useFeatureFlagEnabled } from "posthog-js/react";

export interface FeatureFlagProps {
  flag: string;
  defaultValue?: boolean;
  fallback?: ReactNode;
  children: ReactNode;
}

export const FeatureFlag = ({
  flag,
  defaultValue = false,
  fallback = null,
  children
}: FeatureFlagProps) => {
  const flagValue = useFeatureFlagEnabled(flag);
  const shouldRender = flagValue ?? defaultValue;

  return <>{shouldRender ? children : fallback}</>;
};
